import { render, staticRenderFns } from "./provoffManage.vue?vue&type=template&id=117cc7fb&"
import script from "./provoffManage.vue?vue&type=script&lang=js&"
export * from "./provoffManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports